import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mockup-outer" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h4", {
  class: "toggle-txt toggle-txt-desktop",
  "data-text": "Desktop"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h4", {
  class: "toggle-txt toggle-txt-slash",
  "data-text": "/"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h4", {
  class: "toggle-txt toggle-txt-mobile",
  "data-text": "Mobile"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<span class=\"phone-elem\"></span><span class=\"phone-elem\"></span><span class=\"phone-elem\"></span><span class=\"phone-elem\"></span><span class=\"phone-elem\"></span><span class=\"stand-elem\"></span><span class=\"stand-elem\"></span>", 7)
const _hoisted_13 = { class: "mockup-inner hide-scrollbar" }
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "mockup-trans" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LogoElem = _resolveComponent("LogoElem")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["mockup-mode", {'toggle-disabled': _ctx.mockupChange}]),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.desktopMockup = !_ctx.desktopMockup))
    }, _hoisted_5, 2),
    _createElementVNode("div", {
      class: _normalizeClass(["mockup", {
                'desktop-mockup': _ctx.desktopMockup,
                'mockup-change': _ctx.mockupChange}
            ])
    }, [
      _hoisted_6,
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("img", {
          class: "mockup-img",
          src: _ctx.mockupImg,
          alt: "Project Mockup"
        }, null, 8, _hoisted_14)
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createVNode(_component_LogoElem)
      ])
    ], 2)
  ]))
}